import { SelectorData } from 'src/app/utils/selectorDataType';

export enum RewardType {
  CUSTOMER_SERVICE_EXTENSION = 'CUSTOMER_SERVICE_EXTENSION',
  PRODUCT_DISCOUNT = 'PRODUCT_DISCOUNT',
}

export const selectableRewardTypes: SelectorData[] = [
  {
    label: 'Customer Service Extension',
    value: RewardType.CUSTOMER_SERVICE_EXTENSION,
  },
  { label: 'Product Discount', value: RewardType.PRODUCT_DISCOUNT },
];
